import { EUiStates } from "@constants/enum";
import { ProjectFeatureType } from "@enums/projectFeatureType";
import FeatureIcon from "mdi-react/AccountStarOutlineIcon";
import { ChangeEvent, FormEvent, ReactElement, useState } from "react";
import { Button, ButtonToolbar, Modal } from "reactstrap";
import styles from "./ModalFeatureProject.module.scss";

interface IModalFeatureProject {
  projectName?: string;
  modalStatus: boolean;
  handleModalStatus: () => void;
  modalType: EUiStates.DANGER;
  handleConfirm: (
    unlist: boolean,
    type: ProjectFeatureType,
    order: number
  ) => void;
}

const ModalFeatureProject = ({
  projectName,
  modalStatus,
  handleModalStatus,
  modalType,
  handleConfirm,
}: IModalFeatureProject): ReactElement => {
  const [typeField, setTypeField] = useState("");

  const handleOnChange = (e: ChangeEvent<HTMLSelectElement>) => {
    setTypeField(e.target.value);
  };

  const handleOnSubmit = (form: FormEvent<HTMLFormElement>): void => {
    form.preventDefault();

    const data = new FormData(form.currentTarget);
    const type = data.get("type") as ProjectFeatureType;
    const order = Number(data.get("order"));
    const unlist = type === ProjectFeatureType.Not_Featured;

    handleConfirm(unlist, type, order);
  };

  return (
    <Modal isOpen={modalStatus} className={`modal-dialog--${modalType}`}>
      <form onSubmit={handleOnSubmit}>
        <div className="modal__header">
          <button
            className="lnr lnr-cross modal__close-btn"
            aria-label="modal__close-btn"
            type="button"
            onClick={handleModalStatus}
          />
          <h4 className="text-modal modal__title">
            <span className={styles.verifyIcon}>
              <FeatureIcon />
            </span>
            Project | Feature Status
          </h4>
        </div>

        <div className="modal__body">
          <div>
            Where would you like to feature {projectName}?
            <select
              name="type"
              className={styles.select}
              onChange={handleOnChange}
            >
              {Object.entries(ProjectFeatureType).map((item) => (
                <option
                  selected={item[1] === ProjectFeatureType.Home}
                  value={item[1]}
                >
                  {item[1].replace("-", " ")}
                </option>
              ))}
            </select>
          </div>

          {typeField !== ProjectFeatureType.Not_Featured && (
            <div className={styles.orderSection}>
              What order would you like to give it?
              <select name="order" className={styles.select}>
                {[...Array(5)].map((_, i) => (
                  <option key={i + 1} value={i + 1}>
                    {i + 1}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>

        <ButtonToolbar className="modal__footer">
          <Button onClick={handleModalStatus}>Cancel</Button>
          <Button color={modalType} type="submit">
            Ok
          </Button>
        </ButtonToolbar>
      </form>
    </Modal>
  );
};

export default ModalFeatureProject;
